import { ButtonIcon, MenuRoot, MenuContent, MenuTrigger } from 'shared';
import { iconNames, Icon } from 'shared_DEPRECATED/components/Icon';

import { IChallengeTimelineItem } from 'features/challenge/ChallengeTimelineItem';

import { GoalChallengeCardMenuAddToSprintButton } from './Menu/AddToSprintButton';
import { GoalChallengeCardEditButton } from './Menu/Edit';
import { GoalChallengeCardRemoveButton } from './Menu/Remove';

type TGoalBreakdownChallengeCardMenu = {
  challenge: IChallengeTimelineItem;
  focusAreaId?: string;
};

export const GoalBreakdownChallengeCardMenu = ({
  challenge,
  focusAreaId,
}: TGoalBreakdownChallengeCardMenu) => (
  <MenuRoot>
    <MenuTrigger asChild>
      <ButtonIcon aria-label="open menu" variant="ghost" size="xs">
        <Icon name={iconNames.ellipsisHorizontal} />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent>
      <GoalChallengeCardMenuAddToSprintButton
        challengeId={challenge.challengeId}
      />
      <GoalChallengeCardEditButton challenge={challenge} />
      <GoalChallengeCardRemoveButton
        challengeId={challenge.challengeId}
        focusAreaId={focusAreaId}
      />
    </MenuContent>
  </MenuRoot>
);
